import React, { useState } from "react";
import "../assets/DisbursementReport.css";

const DisbursementReport = () => {
  const [filters, setFilters] = useState({
    employeeId: "",
    branch: "",
    employeeName: "",
  });

  const [reportData, setReportData] = useState([
    {
      id: "EMP001",
      name: "Rajesh Kumar",
      branch: "Delhi",
      amount: 35000,
      mode: "Bank Transfer",
      date: "2025-06-10",
      remarks: "Monthly Salary",
    },
    {
      id: "EMP002",
      name: "Anita Sharma",
      branch: "Mumbai",
      amount: 42000,
      mode: "Cash",
      date: "2025-06-10",
      remarks: "Monthly Salary",
    },
    // Add more dummy data or fetch from API
  ]);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const filteredData = reportData.filter((emp) => {
    return (
      emp.id.toLowerCase().includes(filters.employeeId.toLowerCase()) &&
      emp.branch.toLowerCase().includes(filters.branch.toLowerCase()) &&
      emp.name.toLowerCase().includes(filters.employeeName.toLowerCase())
    );
  });

  return (
    <div className="SalaryDisbursement-wrapper">
      <div className="SalaryDisbursement-container">
        <h2 className="SalaryDisbursement-title">Salary Disbursement Report</h2>

        {/* Filter Form */}
        <div className="SalaryDisbursement-form">
          <div className="SalaryDisbursement-group">
            <label>Employee ID</label>
            <input
              type="text"
              name="employeeId"
              value={filters.employeeId}
              onChange={handleChange}
              placeholder="Enter Employee ID"
            />
          </div>
          <div className="SalaryDisbursement-group">
            <label>Branch</label>
            <input
              type="text"
              name="branch"
              value={filters.branch}
              onChange={handleChange}
              placeholder="Enter Branch"
            />
          </div>
          <div className="SalaryDisbursement-group">
            <label>Employee Name</label>
            <input
              type="text"
              name="employeeName"
              value={filters.employeeName}
              onChange={handleChange}
              placeholder="Enter Employee Name"
            />
          </div>
        </div>

        {/* Report Table */}
        <div className="SalaryDisbursement-report">
          <h3>Filtered Disbursement Report</h3>
          <div className="SalaryDisbursement-tableWrapper">
            <table className="SalaryDisbursement-table">
              <thead>
                <tr>
                  <th>S.N.</th>
                  <th>Employee ID</th>
                  <th>Employee Name</th>
                  <th>Branch</th>
                  <th>Amount</th>
                  <th>Payment Mode</th>
                  <th>Date</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((emp, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{emp.id}</td>
                      <td>{emp.name}</td>
                      <td>{emp.branch}</td>
                      <td>₹{emp.amount.toLocaleString()}</td>
                      <td>{emp.mode}</td>
                      <td>{emp.date}</td>
                      <td>{emp.remarks}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center", color: "#999" }}>
                      No records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisbursementReport;
